import { render, staticRenderFns } from "./ExtraEscolarPage.vue?vue&type=template&id=44672304&scoped=true&"
import script from "./ExtraEscolarPage.vue?vue&type=script&lang=js&"
export * from "./ExtraEscolarPage.vue?vue&type=script&lang=js&"
import style0 from "./ExtraEscolarPage.vue?vue&type=style&index=0&id=44672304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44672304",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/ExtraEscolarPage.vue
// module id = 221
// module chunks = 7